import { Action, createReducer, on } from "@ngrx/store";
import { CaptchaActions } from "../actions";
import { VerifyChallengeOutput } from "@smash-sdk-private/captcha/ejs/10-2025";

export const captchaFeatureKey = 'captcha';

export interface State {
    verifyCaptchaResponse: VerifyChallengeOutput['challenge']['status'];
    verifyCaptchaLoading: boolean;
    verifyCaptchaLoaded: boolean;
    verifyCaptchaError: any;
}

export const initialState: State = {
    verifyCaptchaResponse: null,
    verifyCaptchaLoading: false,
    verifyCaptchaLoaded: false,
    verifyCaptchaError: null,
};

export const captchaReducer = createReducer(
    initialState,
    on(CaptchaActions.ResetVerifyCaptcha, (state) => ({
        ...state,
        verifyCaptchaResponse: initialState.verifyCaptchaResponse,
        verifyCaptchaLoading: initialState.verifyCaptchaLoading,
        verifyCaptchaLoaded: initialState.verifyCaptchaLoaded,
        verifyCaptchaError: initialState.verifyCaptchaError,
    })),
    on(CaptchaActions.VerifyCaptcha, (state) => ({
        ...state,
        verifyCaptchaResponse: initialState.verifyCaptchaResponse,
        verifyCaptchaLoading: true,
        verifyCaptchaLoaded: initialState.verifyCaptchaLoaded,
        verifyCaptchaError: initialState.verifyCaptchaError,
    })),
    on(CaptchaActions.VerifyCaptchaSuccess, (state, { result }) => ({
        ...state,
        verifyCaptchaResponse: result,
        verifyCaptchaLoading: false,
        verifyCaptchaLoaded: true,
    })),
    on(CaptchaActions.VerifyCaptchaFailure, (state, { error }) => ({
        ...state,
        verifyCaptchaLoading: false,
        verifyCaptchaError: error,
    }))
);

export function reducer(state: State | undefined, action: Action) {
    return captchaReducer(state, action);
}
